import react from 'react'
import AboutDirector from './aboutDirector';
import TakeBusiness from './takeBusiness';
// import ClientCarousel from './clientCarouselEsteemed';
// import Technologies from './technologies';
// import Carousel from './carousel';
// import RequestQuote from './requestQuote';

const Abouts = () => {
    return (
        <>
            {/* <AboutDirector /> */}
            <TakeBusiness />
            {/* <Technologies /> */}
            {/* <ClientCarousel /> */}
            {/* <Carousel /> */}
            {/* <RequestQuote/> */}
        </>
    )
}
export default Abouts;